import { IzIntegrationView } from '../view/IzIntegrationView';
import { templateIzIntegration } from '../view/template';
import { IzIntegrationRepository } from '../repository/IzIntegrationRepository';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent
} from '../../framework/BaseWebComponentController';
import { IzIntegrationWebComponent } from '..';
import { IzIntegrationWebComponentSchema } from '../types';

export class IzIntegrationController extends BaseWebComponentController {
  public component: IzIntegrationWebComponent;
  public dataRepository: IzIntegrationRepository;
  public view: IzIntegrationView;
  public viewConstructor: typeof IzIntegrationView;
  public dataRepositoryConstructor: typeof IzIntegrationRepository;

  constructor(component: IzIntegrationWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IzIntegrationView,
      viewTemplate: templateIzIntegration,
      dataRepositoryConstructor: IzIntegrationRepository,
    });
  }

  async getDataForView(): Promise<IzIntegrationWebComponentSchema> {
    return this.dataRepository.getDataForView();
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$redirectButton,
        event: 'click',
        callback: this.openIntellizone,
      },
      {
        element: this.view.dom.$learnMoreButton,
        event: 'click',
        callback: this.openLearnMore,
      },
    ];
  }

  private openIntellizone() {
    // may take from data provider
    const url = 'https://intellizone.bitdefender.com/en/dashboard';
    window.open(url, '_blank');
  }

  private openLearnMore() {
    const url = 'https://www.bitdefender.com/en-us/business/products/operational-threat-intelligence';
    window.open(url, '_blank');
  }

}
